import { createContext, useContext } from 'react';

/**
 * Set only inside the public /try playground, where the plan lives in the browser: screens use it to
 * offer what needs an account (sharing, connecting an assistant) as "available on your own plan".
 */
export interface Playground {
  /** Where "Start yours" goes: pricing, tagged with where the visitor came from. */
  readonly startHref: string;
  /** Opens the note that says what needs an account. */
  readonly explainOwnPlan: (feature: 'share' | 'assistant') => void;
}

export const PlaygroundContext = createContext<Playground | null>(null);

export const usePlayground = (): Playground | null => useContext(PlaygroundContext);
